import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo5/documento1.png";
import Imagen2 from "../../../images/modulo5/documento2.png";
import Imagen3 from "../../../images/modulo5/documento3.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 2.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option2" },
  });
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[1];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[2].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[2].path}`,
    titlePrev: `${modulo5.content[0].activities[0].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          Todos los peruanos y peruanas, desde que nacemos, tenemos un Documento
          Nacional de Identidad (DNI).
        </li>
        <li>
          Selecciona la opción donde aparece el DNI. Pregúntale a tu maestro o
          maestra cuáles son los otros documentos y para qué sirven.
        </li>
      </ul>
      <div className="row align-items-center">
        <div className="col-lg-4 col-md-6 col-12 mb-5">
          <InputRadioButton
            ans={answers.ans1}
            label="ans1"
            value="option1"
            text=""
            handleAnswer={handleAnswer}
          />
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-5">
          <InputRadioButton
            ans={answers.ans1}
            label="ans1"
            value="option2"
            text=""
            handleAnswer={handleAnswer}
          />
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-5">
          <InputRadioButton
            ans={answers.ans1}
            label="ans1"
            value="option3"
            text=""
            handleAnswer={handleAnswer}
          />
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row my-4">
        <div className="col-12">
          <button
            className={`btn float-end btn-${modulo5.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y ayude a identificar el
          DNI. Explique la función del pasaporte (sirve para viajar e
          identificarse en el extranjero) y la licencia de conducir (certifica
          que podemos manejar ciertos vehículos).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
